import { useTranslation } from 'react-i18next'
import { AVAILABILITY_SLOT_OPTIONS, hasAvailabilitySlot } from './availabilitySlots'

function AvailabilitySlotPicker({ selectedSlots = [], onSlotToggle }) {
	const { t } = useTranslation()

	return (
		<div className="grid gap-4 md:grid-cols-2">
			{AVAILABILITY_SLOT_OPTIONS.map(slot => {
				const selected = hasAvailabilitySlot(selectedSlots, slot.id)
				const isFirstHalf = slot.id === '8-14'
				const selectedClass = isFirstHalf
					? 'border-amber-500 bg-amber-50 shadow-sm'
					: 'border-violet-500 bg-violet-50 shadow-sm'
				const badgeClass = isFirstHalf
					? 'bg-amber-500 text-white'
					: 'bg-violet-600 text-white'

				return (
					<button
						key={slot.id}
						type="button"
						onClick={() => onSlotToggle(slot.id)}
						className={`rounded-2xl border p-4 text-left transition ${
							selected
								? selectedClass
								: 'border-gray-200 bg-white hover:border-gray-300 hover:bg-gray-50'
						}`}>
						<div className="flex items-start justify-between gap-3">
							<div>
								<h4 className="text-base font-semibold text-gray-900">{slot.label}</h4>
								<p className="mt-1 text-sm text-gray-500">
									{selected
										? t('trainingAvailability.add.dayOverview.selected')
										: t('trainingAvailability.add.dayOverview.clickToToggle')}
								</p>
							</div>
							<span
								className={`rounded-full px-2.5 py-1 text-xs font-semibold ${
									selected ? badgeClass : 'bg-gray-100 text-gray-600'
								}`}>
								{selected
									? t('trainingAvailability.add.dayOverview.active')
									: t('trainingAvailability.add.dayOverview.inactive')}
							</span>
						</div>
					</button>
				)
			})}
		</div>
	)
}

export default AvailabilitySlotPicker
